import React, { ReactNode } from "react";

import { Spacer } from "@/components/common";
import { WeatherIcon } from "@/components/header/Weather/components/icons/WeatherIcon";
import { Weather } from "@/models/weather";

type Props = {
  weather: Weather;
  label: string | ReactNode;
};

export const WeatherIconWithLabel = ({ weather, label }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <WeatherIcon weather={weather} />
      <Spacer y="8px" />
      <span className="text-[1.1rem] leading-none">{label}</span>
    </div>
  );
};
